import React, { createContext, useContext, useState } from 'react';

const BasketContext = createContext();

export const BasketProvider = ({ children }) => {
  const [basket, setBasket] = useState([]);

  const addToBasket = (module) => {
    setBasket((prev) => {
      const uniqueId = `${module.Category}/${module.Module}`;
      if (prev.some((item) => `${item.Category}/${item.Module}` === uniqueId)) {
        return prev;
      }
      return [...prev, module];
    });
  };

  const removeFromBasket = (category, moduleId) => {
    setBasket((prev) => {
      const uniqueId = `${category}/${moduleId}`;
      return prev.filter((item) => `${item.Category}/${item.Module}` !== uniqueId);
    });
  };

  const clearBasket = () => setBasket([]);

  return (
    <BasketContext.Provider value={{ basket, addToBasket, removeFromBasket, clearBasket }}>
      {children}
    </BasketContext.Provider>
  );
};

export const useBasket = () => useContext(BasketContext);
